import { formatToCurrency } from "@shared/utils/formatters";
import {
  Card,
  ProductInfo,
  ProductNameContainer,
  Price,
  ProductDescription,
  TotalInfo,
  TotalItem,
  StyledDivider,
} from "./styles";
import { BasicPlanProps } from "./PriceBreakdown.types";
import { Typography } from "@mui/material";

export const BasicPlanPriceBreakdown = (props: BasicPlanProps) => {
  const { price, productName, productDescription, currency = "USD", hideMarketingCopy } =
    props;
  const priceInDollars = price / 100;

  return (
    <Card>
      {!hideMarketingCopy && (
        <>
          <ProductInfo>
            <ProductNameContainer>
              <Typography>{productName}</Typography>
            </ProductNameContainer>
            {!!productDescription && (
              <ProductDescription>{productDescription}</ProductDescription>
            )}
          </ProductInfo>
          <StyledDivider sx={{ margin: "0 1.5rem" }} />
        </>
      )}
      <TotalInfo>
        <TotalItem>
          <Typography>Total</Typography>
          <Price>
            <span data-testid="offer-price-after-discount">
              {currency.toUpperCase()} {formatToCurrency(priceInDollars)} /
              month
            </span>
          </Price>
        </TotalItem>
      </TotalInfo>
    </Card>
  );
};
